<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="profissaoLocal.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="!canEditOrInsert"
                  data-cy="description-input"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="cbo"
              rules="required"
            >
              <b-form-group
                label="CBO"
                label-for="v-cbo"
              >
                <b-form-input
                  id="v-cbo"
                  v-model="profissaoLocal.cbo"
                  placeholder="CBO"
                  :disabled="!canEditOrInsert"
                  data-cy="cbo-input"
                  :state="errors.length > 0 ? false : null"
                />
                <small
                  data-cy="v-cbo-validate"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="profissaoLocal.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="profissaoLocal.ativo"
                :checked="profissaoLocal.ativo"
                name="check-button"
                switch
                inline
                :disabled="!canEditOrInsert"
                data-cy="active-checkbox"
              >
                {{ profissaoLocal.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'

import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('professionsSettingsModule', {
      profissao: state => state.profissao,
    }),
    canInsert() {
      return verificarPermissao('ROLE_PROFISSAO_INSERIR')
    },
    canEdit() {
      return verificarPermissao('ROLE_PROFISSAO_ATUALIZAR')
    },
    canEditOrInsert() {
      return (!this.profissaoLocal.id && this.canInsert) || (this.profissaoLocal.id && this.canEdit)
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Profissões',
      required,
      profissaoLocal: {
        nome: '',
        cbo: null,
        ativo: true,
      },
    }
  },
  mounted() {
    this.profissaoLocal = JSON.parse(JSON.stringify(this.profissao))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('professionsSettingsModule/resetProfession')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.profissaoLocal.id) {
            this.$store
              .dispatch('professionsSettingsModule/editProfession', this.profissaoLocal)
              .then(response => {
                if (response.response) {
                  this.MensagemError('Falha ao Editar', response.response.data.error)
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('professionsSettingsModule/insertNewProfession', this.profissaoLocal)
              .then(response => {
                if (response.response) {
                  this.MensagemError('Falha ao Inserir', response.response.data.error)
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.profissaoLocal = {
        nome: '',
        cbo: null,
        ativo: true,
      }
    },
  },
}
</script>
